<div class="media__dropzone">
  <swb-dropzone (queueCompleted)="reloadList($event)"></swb-dropzone>
</div>

<div class="clearfix">
  <div style="float:left;">
    <pagination-controls
      *ngIf="pagination.pageSize > 0 && isInitialized"
      id="media"
      (pageChange)="pageChanged($event)"
      maxSize="9"
      directionLinks="true"
      autoHide="true"
      previousLabel=""
      nextLabel=""
      screenReaderPaginationLabel="Pagination"
      screenReaderPageLabel="Stránka"
      screenReaderCurrentLabel="Jste na stránce"
    >
    </pagination-controls>
  </div>
  <div style="float:right;">
    <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
  </div>
</div>

<div id="file-list" class="paginated-content media__list" *ngIf="isInitialized">
  <div
    *ngFor="
      let file of (items
        | paginate
          : {
              id: 'media',
              itemsPerPage: pagination.pageSize,
              currentPage: p,
              totalItems: pagination.total
            })
    "
    class="media__list__item"
  >
    <div
      class="media__list__item__box"
      [ngStyle]="
        getBoxStyle(file.is_image, file.is_resizable, file.file_fullname)
      "
    >
      <div
        class="media__list__item__filetype media__list__item__filetype--{{file.extension}}"
      >
        {{ file.extension }}
      </div>
      <div class="media__list__item__filename" *ngIf="!file.is_image">
        <span class="media__list__item__filename__inside">{{
          file.file_name
        }}</span>
      </div>
      <div class="media__list__item__actions">
        <div class="media__list__item__actions__title">
          {{ file.file_name }}
        </div>
        <br />

        <a
          [routerLink]="{ outlets: { modal: [file.id] } }"
          class="media__list__item__actions__link media__list__item__actions__link--edit"
          title="Upravit soubor."
        >
          <i class="ico-edit"></i>
        </a>

        <a
          *ngIf="file.is_image"
          [routerLink]="{ outlets: { modal: ['zoom', file.id] } }"
          class="media__list__item__actions__link media__list__item__actions__link--view"
          title="Zobrazit obrázek v plné velikosti."
        >
          <i class="ico-magnifier"></i>
        </a>

        <a
          href="{{downloadUrl}}{{file.id}}"
          target="_blank"
          class="media__list__item__actions__link media__list__item__actions__link--download"
          title="Stáhnout soubor."
        >
          <i class="ico-download"></i>
        </a>

        <a
          [routerLink]="{ outlets: { modal: ['delete', file.id] } }"
          class="media__list__item__actions__link media__list__item__actions__link--remove"
          [queryParams]="{
            header: 'Opravdu chcete smazat soubor ' + file.file_name + '?',
            body:
              'Tato akce odstraní soubor i ze všech záznamů, ke kterým je přidružen.'
          }"
          title="Smazat soubor."
        >
          <i class="ico-remove"></i>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="loading loading--dark" *ngIf="!isInitialized"></div>
<pagination-controls
  *ngIf="pagination.pageSize > 0 && isInitialized"
  id="media"
  (pageChange)="pageChanged($event)"
  maxSize="9"
  directionLinks="true"
  autoHide="true"
  previousLabel=""
  nextLabel=""
  screenReaderPaginationLabel="Pagination"
  screenReaderPageLabel="Stránka"
  screenReaderCurrentLabel="Jste na stránce"
>
</pagination-controls>

<swb-no-data *ngIf="items && items.length === 0"></swb-no-data>
